export default __webpack_public_path__ + "static/media/img2.ac558917.jpeg";